export default __webpack_public_path__ + "static/media/contact-04.934f61c0.png";